import { render, staticRenderFns } from "./ComplaintMarker.vue?vue&type=template&id=56d6820d&"
import script from "./ComplaintMarker.vue?vue&type=script&lang=js&"
export * from "./ComplaintMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports